import { render, staticRenderFns } from "./OrderSyncHistory.vue?vue&type=template&id=a6081ffc&"
import script from "./OrderSyncHistory.vue?vue&type=script&lang=js&"
export * from "./OrderSyncHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports